class CartIconBubble extends HTMLElement {
  /** @type {HTMLElement | null} */
  toggleButton = this.querySelector('[aria-controls="cart-drawer"]') || null;

  /** @type {HTMLElement | null} */
  cartDrawer = document.querySelector('cart-drawer') || null;

  addToCartBehavior = this.getAttribute('add-to-cart-behavior') || null;

  abortController = new AbortController();

  countTarget = this.querySelector('[data-cart-count]');

  connectedCallback() {
    if (this.cartDrawer && this.addToCartBehavior === 'show_cart_drawer') {
      this.toggleButton.addEventListener('click', this.toggle.bind(this));
    }

    document.addEventListener('cart-updated', () => {
      this.updateCount();
    });
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    document.body?.classList?.contains(this.cartDrawer.activeClass)
      ? this.cartDrawer.close()
      : this.cartDrawer.open();
  }

  async updateCount() {
    if (!this.countTarget) return;

    this.abortController.abort();
    this.abortController = new AbortController();

    try {
      const response = await fetch('/cart.json', {
        signal: this.abortController.signal,
      });
      if (!response.ok) {
        throw new Error(response.statusText);
      }

      const { item_count } = await response.json();
      this.countTarget.textContent = item_count;
      parseInt(item_count) > 0
        ? this.countTarget.classList.remove('hidden')
        : this.countTarget.classList.add('hidden');
    } catch (error) {
      console.error(error);
    }
  }
}

if (!customElements.get('cart-icon-bubble')) {
  customElements.define('cart-icon-bubble', CartIconBubble);
}
